import type {
  ManualCheckPaymentDetail,
  ManualCheckPaymentListItem,
} from "@/hera-api/manual-check-payments-api";

/** License + payment row to pass to ``/shared/licenses/.../receipt`` PDF endpoints. */
export type ManualCheckReceiptAnchor = {
  licenseId: string;
  paymentId: string;
  isInspection: boolean;
};

/**
 * Pick one license payment or inspection payment from check detail for receipt download.
 * Combined checkouts share one receipt; any sibling id works for the API.
 */
export function pickManualCheckReceiptAnchor(
  detail: ManualCheckPaymentDetail,
): ManualCheckReceiptAnchor | null {
  for (const lic of detail.licenses) {
    if (lic.payments.length > 0) {
      return {
        licenseId: lic.license_id,
        paymentId: lic.payments[0].id,
        isInspection: false,
      };
    }
  }
  for (const lic of detail.licenses) {
    const insp = lic.inspection_payment;
    if (insp && Number.parseFloat(insp.fee_paid) > 0) {
      return {
        licenseId: lic.license_id,
        paymentId: insp.id,
        isInspection: true,
      };
    }
  }
  return null;
}

/**
 * Receipt anchor from registrant/operator payments list row.
 * List rows always include at least one license payment when present (backend skips
 * inspection-only transactions). Uses the first period payment and row ``license_id``,
 * matching ``pickManualCheckReceiptAnchor`` for the common case.
 */
export function pickManualCheckReceiptAnchorFromListItem(
  row: ManualCheckPaymentListItem,
): ManualCheckReceiptAnchor | null {
  if (row.payments.length > 0) {
    return {
      licenseId: row.license_id,
      paymentId: row.payments[0].id,
      isInspection: false,
    };
  }
  return null;
}
